import React, { useEffect } from "react"
import { useParams } from "react-router-dom"

import { IconCircleCrossExtraLarge, IconCircleTickExtraLarge } from "@izettle/otto"
import { Loader, LoaderSize, Text, TextAnchor, SvgIcon } from "@izettle/react"
import { useLocalization } from "@izettle/tenko-react"

import { Page } from "@/core/components/shared"
import { useMemberMerchantDetails } from "@/modules/members/api/use-merchant-details"
import { useMemberOptin } from "@/modules/members/api/use-opt-in"
import {
  TrackingPage,
  TrackingAction,
  useTracking,
} from "@/modules/members/hooks/members-tracking"
import { Container, Header, Content } from "@/modules/members/pages/styles"

export default function MembersOptInPage() {
  const { text } = useLocalization()
  const { track } = useTracking(TrackingPage.Optin)

  const { memberUuid } = useParams<{
    memberUuid: string
  }>()

  const { data, isFetching } = useMemberMerchantDetails(memberUuid ?? "")
  const {
    mutate,
    data: optinResponse,
    isLoading,
  } = useMemberOptin(() => {
    track(TrackingAction.OptinSuccess)
  })

  useEffect(() => {
    if (data?.contactEmail && memberUuid) {
      mutate(memberUuid)
    }
  }, [data?.contactEmail])

  if (isFetching || isLoading) {
    return (
      <Page data-testid="loading">
        <Loader size={LoaderSize.Large} />
      </Page>
    )
  }

  return (
    <Page>
      <Container>
        {data?.contactEmail && optinResponse?.isVerified ? (
          <>
            <Header>
              <Text.Title2>{data?.legalName}</Text.Title2>
              <TextAnchor href={`mailto:${data?.contactEmail}`}>
                {data?.contactEmail}
              </TextAnchor>
            </Header>
            <Content isSuccess>
              <SvgIcon icon={IconCircleTickExtraLarge} color="success" />
              <Text.LargeBold>{text("MEMBERS_OPTIN_SUCCESS_TITLE")}</Text.LargeBold>
              <Text.Regular>{text("MEMBERS_OPTIN_SUCCESS_TEXT")}</Text.Regular>
            </Content>
          </>
        ) : (
          <Content>
            <SvgIcon icon={IconCircleCrossExtraLarge} color="error" />
            <Text.LargeBold>{text("MEMBERS_OPTIN_FAILURE_TITLE")}</Text.LargeBold>
            <Text.Regular>{text("MEMBERS_OPTIN_FAILURE_TEXT")}</Text.Regular>
          </Content>
        )}
      </Container>
      <Text.RegularSecondary>{"Zettle by Paypal"}</Text.RegularSecondary>
    </Page>
  )
}
